import Head from 'next/head';
import type { AppProps } from 'next/app';
// import { appWithTranslation } from 'next-i18next';
import { PersistGate } from 'redux-persist/integration/react';
import { Providers } from '~/GlobalRedux/provider';
import { persistor, store } from '~/GlobalRedux/store';
import ErrorSnackbar from '~/components/ErrorSnackBar';
import SuccessSnackbar from '~/components/SuccessSnackBar';
import axiosInterceptor from '~/api/services/axiosInterceptor';
import '~/styles/globals.css';

const MyApp = ({ Component, pageProps }: AppProps) => {
  axiosInterceptor(store);

  return (
    <Providers>
      <Head>
        <title>Portal Peipedê</title>
        <meta name="description" content="Portal Peipedê" />
        <meta property="og:title" content="Portal Peipedê" />
        <meta property="og:description" content="Portal Peipedê" />
        <meta property="og:image" content="/Images/icone.ico" />
        <link rel="icon" href="/Images/icone.ico" />
      </Head>
      <PersistGate loading={null} persistor={persistor}>
        <Component {...pageProps} />
        <ErrorSnackbar />
        <SuccessSnackbar message={''} />
      </PersistGate>
    </Providers>
  );
};

// export default appWithTranslation(MyApp);
export default MyApp;